import { render } from "./ModalSeleccionObjetosIniciales.vue?vue&type=template&id=44b0b62c&scoped=true"
import script from "./ModalSeleccionObjetosIniciales.vue?vue&type=script&lang=js"
export * from "./ModalSeleccionObjetosIniciales.vue?vue&type=script&lang=js"

import "./ModalSeleccionObjetosIniciales.vue?vue&type=style&index=0&id=44b0b62c&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b0b62c"]])

export default __exports__